import { CountryState } from '@/model/CountryState'
import axios from 'axios'

const initialState = {
  loaded: false,
  list: [],
  dictionary: {},
} as CountryState

export const countries = {
  namespaced: true,
  state: initialState,
  actions: {
    load({ commit }: Record<any, any>, api: typeof axios) {
      api.get('/countries').then((response: any) => {
        const countries = response.data['items']

        const dictionary = {} as Record<string, string>
        for (let i = 0; i < countries.length; i++) {
          dictionary[countries[i].code] = countries[i].name
        }

        commit('loaded', { countries, dictionary })
      })
    },
  },
  mutations: {
    loaded(state: CountryState, { countries, dictionary }: Record<any, any>) {
      state.loaded = true
      state.list = countries
      state.dictionary = dictionary
    },
  },
}
